import { FC } from 'react';

import { Button } from '@thirdspacelearning/library';
import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

import { User } from '../../types';

interface Props {
    user: User | null;
}

const LogoutButton: FC<Props> = ({ user }) => {
    const { login, logout } = useKeycloakAuth();

    if (user) {
        return (
            <Button color="primary" variant="outlined" onClick={logout}>
                Logout
            </Button>
        );
    }

    return (
        <Button color="primary" variant="outlined" onClick={login}>
            Login
        </Button>
    );
};

export default LogoutButton;
